'use client';

import React from 'react';
import styled from '@emotion/styled';
import { Css, Responsive } from '@/ui';
import ReloadPageButton from '../../../../components/common/button/ReloadPageButton';
import { Color } from '../../../../styles/Color';
import { ErrorMessages } from '../../../../utils/errorMessages';
import { getHeadingStyle } from '../../../../styles/utils/getHeadingStyle';
import { theme } from '../../../../styles/theme';

interface IErrorMessage {
	title?: string;
	message?: string;
	showReloadButton?: boolean;
}

export default function ErrorMessage({
	title,
	message,
	showReloadButton = true,
}: IErrorMessage) {
	return (
		<Root>
			<Title>{title || 'Something went wrong'}</Title>
			<Description>{message || ErrorMessages.GenericError} </Description>
			{showReloadButton && <ReloadPageButton />}
		</Root>
	);
}

export const Root = styled.div`
	padding: ${Css.pxToRem(100)};
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	align-items: center;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${Css.pxToRem(90)} ${Css.pxToRem(24)} ${Css.pxToRem(50)};
	}
`;

export const Title = styled.h2`
	${getHeadingStyle(theme, 'h4')}
	margin-bottom: 0;
	color: ${Color.PrimaryBlue};
	line-height: normal;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRem(30)};
	}
`;

export const Description = styled.p`
	margin-bottom: ${Css.pxToRem(20)};
	max-width: 280px;
`;
